import BaseComponent from "@js/components/base_component.jsx";

class MuiSubAccountsIndexTable extends BaseComponent {

  render() {
    return this.props.sub_accounts.length > 0 ? (
      <table className="table table-hover">
        <thead>
          <tr>
            <th className="column-name">{ t("headings.name") }</th>
            <th className="column-name" style={{width: "200px"}}>{ t("headings.client_ids") }</th>
            <th className="column-name">{ t("headings.from_domains") }</th>
            <th className="column-actions" style={{width: "275px"}}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>{this._renderRows()}</tbody>
      </table>
    ) : (
      <EmptyTableNotification type={I18n.t("sections.accounts")} offerNew={ false } />
    );
  }

  _renderRows() {
    return this.props.sub_accounts.map((subAccount, i) => {
      return (
        <tr key={ i }>
          <td>{ subAccount.name }</td>
          <td>{ this._renderClientIDs(subAccount) }</td>
          <td>{ this._renderFromDomains(subAccount) }</td>
          <td className="text-right index-buttons">
            {
              this.props.offer_edit &&
                <ButtonEdit
                  href={ Routes.edit_mui_sub_account_path(subAccount.id, { return_to: window.location.href }) }
                  size="small"
                />
            }
            <ButtonView
              href={ Routes.mui_sub_account_path(subAccount.id) }
              size="small"
            />
            {
              this.props.is_master_user && (
                <ButtonWithIcon
                  href={ Routes.sudo_mui_sub_account_path(subAccount.id) }
                  icon="play-circle"
                  type="index"
                  size="small"
                >
                  { t("buttons.sign_in_as") }
                </ButtonWithIcon>
              )
            }
          </td>
        </tr>
      );
    });
  }

  _renderClientIDs(subAccount) {
    if ( subAccount.access_all_client_ids && subAccount.access_all_from_domains ) {
      return <i>All</i>;
    } else if ( subAccount.access_all_client_ids ) {
      return <span>&mdash;</span>;
    } else if ( subAccount.access_client_ids_list.length === 0 ) {
      return <i>None</i>;
    } else {
      return subAccount.access_client_ids_list.join(", ");
    }
  }

  _renderFromDomains(subAccount) {
    if ( subAccount.access_all_client_ids && subAccount.access_all_from_domains ) {
      return <i>All</i>;
    } else if ( subAccount.access_all_from_domains ) {
      return <span>&mdash;</span>;
    } else if ( subAccount.access_from_domains_list.length === 0 ) {
      return <i>None</i>;
    } else if ( subAccount.access_from_domains_list.length > 5 ) {
      return subAccount.access_from_domains_list.slice(0, 5).join(", ") + ", ...";
    } else {
      return subAccount.access_from_domains_list.join(", ");
    }
  }

}

export default MuiSubAccountsIndexTable;
